<!--订单列表-->
<template>
  <div>
    <van-tabs v-model:active="active" class="tab-nav" sticky @click="onStatusChange">
      <van-tab title="全部"></van-tab>
      <van-tab title="待付款"></van-tab>
      <van-tab title="待拼团"></van-tab>
      <van-tab title="待发货"></van-tab>
      <van-tab title="待收货"></van-tab>
      <van-tab title="售后中"></van-tab>

      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="row-list" v-for="(order, index) in list" :key="index">
            <div class="justify-space-flex row-title">
              <div class="title-left flex-start gray">
                <van-checkbox
                  style="margin-right:8px;"
                  v-model="order.checked"
                  checked-color="#07c160"
                  v-if="order.status_buttons.name == '待支付'"
                  @click="onGoodsChange(order, order.checked)"
                ></van-checkbox>
                <div class="business-info" v-if="order.open_seller_fenxiao==2">
                  <img class="row-title-img" :src="order.business_pic_url" alt />
                  {{order.business_name}}
                </div>
              </div>

              <div class="title-right">{{order.status_buttons.name}}</div>
            </div>
            <div
              class="justify-space-flex row-goods"
              v-for="(goods, index) in order.items"
              @click="goOrderDetail(order.id,order.type, order)"
            >
              <div class="row-left flex-start">
                <img class="row-left-img" :src="goods.pic_url" alt />
                <div class="goods-detail">
                  <div class="goods-name">{{goods.title}}</div>
                  <div class="goods-weight gray-light">{{goods.sku.sku_formart}}</div>
                </div>
              </div>
              <div class="row-right">
                <div class="goods-price">
                  <span>¥</span>
                  {{goods.goods_price_base}}
                </div>
                <div class="goods-num gray-light">数量 {{goods.count}}</div>
              </div>
            </div>

            <van-notice-bar
              :text="'可用时限'+ order.use_time_range[0] +'  ~  '+order.use_time_range[1]"
              v-if="order.use_time_range"
            ></van-notice-bar>
            <div
              class="row-btn"
              v-if="order.status_buttons.buttons.length>0"
              @click="goOrderDetail(order.id,order.type, order)"
            >
              <div
                :class="btn.class+'-btn'"
                v-for="(btn,index) in order.status_buttons.buttons" :key="index"
              >{{btn.name}}</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </van-tabs>

    <div style="height:50px;"></div>
    <!-- <div class="footer flex-between" v-if="active == 0 || active == 1">
      <div class="footer-left">
        总计
        <span>¥{{totalPrice}}</span>
      </div>
      <div class="footer-right" @click="submit">支付</div>
    </div> -->
    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
    <PayDialog
      :show="payShow"
      :ids="orderIds"
      :key="timer"
      @onPayError="onPayError"
      @onPaySuccess="onPaySuccess"
      @onPayClose="onPayClose"
    />
  </div>
</template>
<style scoped>
@import "../../assets/style/amendVant.css";

.normal-btn {
  width: 75px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 1);
  margin-left: 15px;
}

.primary-btn {
  width: 105px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  background: rgba(255, 0, 0, 1);
  border-radius: 4px;
  margin-left: 15px;
}

.row-list {
  border-bottom: 0.1rem solid #efefef;
}

.row-title-img {
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.1rem;
}

.row-title {
  padding: 0.1rem 0.33rem;
  border-bottom: 1px solid #efefef;
}

.business-info {
  display: flex;
  align-items: center;
}
.title-right {
  color: #fd2840;
  display: flex;
  align-items: center;
}

.row-left {
  width: 80%;
}

.row-right {
  text-align: center;
}

.goods-detail {
  width: 72%;
}

.row-left-img {
  width: 1.44rem;
  height: 1.44rem;
  border-radius: 5px;
  margin-right: 0.2rem;
}

.row-goods {
  padding: 0.2rem 0.3rem;
  border-bottom: 1px solid #efefef;
}

.goods-name {
  font-size: 12px;
  margin-bottom: 0.6rem;
}

.goods-price {
  font-size: 16px;
  color: #fd2840;
  margin: 0.1rem 0 0.6rem;
}

.goods-price span {
  font-size: 12px;
}

.goods-num {
  font-size: 12px;
}

.row-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.2rem 0.33rem;
  font-size: 12px;
  text-align: center;
  line-height: 0.52rem;
}

.look-order {
  width: 1.5rem;
  height: 0.52rem;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 1);
  text-align: center;
  margin-right: 0.3rem;
}

.invite-btn {
  width: 2.1rem;
  height: 0.52rem;
  background: rgba(255, 0, 0, 1);
  border: 1px solid rgba(255, 0, 0, 1);
  border-radius: 4px;
  color: #fff;
}

.footer {
  position: fixed;
  bottom: 0px;
  left: 0;
  /*width: 375px;*/
  width: 100%;
  height: 44px;
  line-height: 44px;
  background: #fff;
  z-index: 8;
}

.footer-left {
  width: 218px;
  font-size: 12px;
  color: #111111;
  padding-left: 16.5px;
  border-top: 1px solid #efefef;
}

.footer-left span {
  font-size: 17px;
  font-weight: bolder;
  margin-left: 5px;
}

.footer-empty {
  width: 157px;
  color: #666;
  font-size: 14px;
}

.footer-delete {
  width: 157px;
  background: #ff976a;
  color: #fff;
  text-align: center;
  border-top: 1px solid #ff976a;
}

.footer-right {
  width: 157px;
  background: #fd2840;
  color: #fff;
  text-align: center;
  border-top: 1px solid #ff976a;
}
</style>

<script>
import Vue from "vue";
import { Tab, Tabs, PullRefresh, List, NoticeBar, Toast, Checkbox } from "vant";
Vue.use(Tab).use(Tabs);
import PayDialog from "@/components/PayDialog.vue";
import LoginDialog from "@/components/LoginDialog.vue";

export default {
  name: "OrderList",
  components: {
    Tab,
    Tabs,
    Toast,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [NoticeBar.name]: NoticeBar,
    [Checkbox.name]: Checkbox,
    LoginDialog,
    PayDialog
  },
  data: function() {
    return {
      loginShow: false,
      payShow: false,
      active: 0,
      totalPrice: 0,
      isLoading: false,
      loading: false,
      finished: false,
      params: {
        p: 1,
        step: 5,
        status: 0
      },
      homeTop: 0,
      list: [],

      orderIds: [],
      timer: ""
    };
  },
  filter: {},
  activated() {
    let that = this;
    document.title = "订单列表";

    // console.log(this.$route.meta)
    if (!this.$route.meta.isBack) {
      // 清空查询条件和数据
      that.list = [];
      that.active = 0;
      that.params.p = 1;
      that.params.status = 0;
      that.loading = true;
      that.finished = false;
      that.getOrderList();

      if (this.$route.query.status) {
        that.active = that.params.status = this.$route.query.status;
        that.active = Number(that.active)
      }
    }
    document.getElementById("app").scrollTop = this.homeTop || 0;
    this.$route.meta.isBack = false;
  },
  mounted() {},
  destroyed() {},
  beforeRouteEnter(to, from, next) {
    if (
      from.path == "/orderdetail" ||
      from.path == "/shoporderdetail" ||
      from.path == "/tuanshare"
    ) {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }
    next();
  },
  methods: {
    // 获取订单来列表
    getOrderList(ref) {
      let that = this;
      this.$api.get(
        "/api/order/orderList",
        that.params,
        res => {
          that.loading = false;
          that.params.p += 1;

          if (res.data.currentpage == 1) {
            if (ref) {
              that.$toast("刷新成功");
            }
            that.isLoading = false;
            that.list = res.data.list;
          } else {
            let list = that.list.concat(res.data.list);
            that.list = list;
          }
          if (res.data.list.length == 0) {
            that.finished = true;
          }
        },
        res => {
          if (res.code == 401 || res.code == 402) {
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },

    submit() {
      let that = this;
      that.payShow = true;
      console.log(that.orderIds);
    },

    onGoodsChange(order, status) {
      console.log("onGoodsChange", order, !status);
      let that = this;
      if (status) {
        that.orderIds.push(order.id);
        that.totalPrice += order.pay_price;
      } else {
        that.orderIds.map((list, listIndex) => {
          if (list == order.id) {
            that.orderIds.splice(listIndex, 1);
          }
        });
        that.totalPrice -= order.pay_price;
      }
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.getOrderList();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },

    onPayError() {
      this.payShow = false;
    },

    onPaySuccess() {
      this.payShow = false;
      this.totalPrice = 0;
      this.orderIds = [];
      this.params.p = 1;
      this.orderList = [];
      this.timer = new Date().getTime();
      this.getOrderList();
      // console.log(data);
    },

    onPayClose() {
      this.payShow = false;
      // this.getOrderDetail();
    },

    // 更改状态
    onStatusChange(index) {
      let that = this;
      that.params.status = index;
      that.params.p = 1;

      // 激活下拉
      that.finished = false;
      that.loading = true;
      that.list = [];

      this.$route.query.status = 0;
      that.getOrderList();
    },

    // 跳转订单详情
    goOrderDetail(id, type, order) {
      // 判断是否成团

      if (
        order.status_buttons.buttons[0] &&
        order.status_buttons.buttons[0].type == "tuanShare"
      ) {
        let url = "TuanShare";
        rbLink({
          name: url.substring(0, 1).toUpperCase() + url.substring(1),
          query: { id: id }
        });

        return;
      }

      let url = "";
      if (type == "base") {
        url = "OrderDetail";
      } else if (type == "shop") {
        url = "ShopOrderDetail";
      }

      if (type == "shop") {
        url = "ShopOrderDetail";
      } else {
        url = "OrderDetail";
      }

      rbLink({
        name: url.substring(0, 1).toUpperCase() + url.substring(1),
        query: { id: id }
      });
    },

    // 上拉加载
    onLoad() {
      // 异步更新数据
      if (this.params.p > 1) {
        setTimeout(() => {
          this.getOrderList();
        }, 500);
      }
    },

    onRefresh() {
      let that = this;
      that.params.p = 1;
      this.getOrderList(1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// OrderListDemo.vue?0f0c1550